import { createStore, applyMiddleware } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import cloneDeep from 'lodash/cloneDeep';

import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers/index';
import logger from 'redux-logger';
import env from './config/environment';

import { initAuthenticationSaga } from './sagas/initialize/sagas_initialize';

import { fork, all } from 'redux-saga/effects';

const environment = process.env.REACT_APP_ENV || env();

const immutableActionMiddleware = () => (next) => (action) => {
  return next(cloneDeep(action));
};

function* preSetupSagas() {
  yield all([
    fork(initAuthenticationSaga),
  ]);
}

// ============ SAGA and STORE ============
// Initialize the saga middleware
const defaultState = {};
const sagaMiddleware = createSagaMiddleware();

const applicableMiddlewares = [immutableActionMiddleware, sagaMiddleware];

if (environment !== 'release') {
  applicableMiddlewares.push(logger);
}

const store = createStore(rootReducer, defaultState, applyMiddleware(...applicableMiddlewares));
export const historySyncWithStore = syncHistoryWithStore(browserHistory, store);
export default store;

if (environment === 'development') {
  window.store = store;
}

sagaMiddleware.run(preSetupSagas);
